import { useState } from "react";
import { Mui } from "@osu/react-ui";
import { FORM_STATUSES, FORM_STATUS_LABELS } from "../../../../util/constants";
import { useUpdateFormStatusMutation } from "../../../../services/form/api";

const statusOptions = [
  FORM_STATUSES.DRAFT,
  FORM_STATUSES.SUBMITTED,
  FORM_STATUSES.REPORTED_ED_1,
  FORM_STATUSES.REPORTED_ED_2,
  FORM_STATUSES.DELETED,
];

function BulkStatusUpdate({ selectedRows, onComplete }) {
  const [status, setStatus] = useState("");
  const [updateFormStatus, { isLoading }] = useUpdateFormStatusMutation();

  const handleApply = async () => {
    if (!status || !selectedRows?.length) return;

    const promises = selectedRows.map((row) =>
      updateFormStatus({
        formType: row.type,
        identifier: row.id,
        status,
      })
    );

    await Promise.allSettled(promises);
    setStatus("");
    onComplete && onComplete();
  };

  return (
    <Mui.Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1 }}>
      <Mui.Typography variant="body2">
        {selectedRows.length} selected
      </Mui.Typography>
      <Mui.FormControl size="small" sx={{ minWidth: 180 }}>
        <Mui.InputLabel id="bulk-status-label">Status</Mui.InputLabel>
        <Mui.Select
          labelId="bulk-status-label"
          value={status}
          label="Status"
          onChange={(e) => setStatus(e.target.value)}
        >
          {statusOptions.map((key) => (
            <Mui.MenuItem key={key} value={key}>
              {FORM_STATUS_LABELS[key] || key}
            </Mui.MenuItem>
          ))}
        </Mui.Select>
      </Mui.FormControl>
      <Mui.Button
        variant="contained"
        size="small"
        disabled={!status || isLoading}
        onClick={handleApply}
      >
        {isLoading ? "Updating..." : "Apply"}
      </Mui.Button>
    </Mui.Box>
  );
}

export default BulkStatusUpdate;
